export default __webpack_public_path__ + "static/media/405.53acc0cf.png";